import { immer } from '../middelware/immer'
import create, { GetState, SetState } from 'zustand'
import { StoreApiWithDevtools, StoreApiWithPersist, devtools, persist } from 'zustand/middleware'

export type AddressView = 'grid' | 'list'

export type AddressViewStore = {
  view: AddressView
  setView: (view: AddressView) => void
}

export const useAddressViewStore = create<
  AddressViewStore,
  SetState<AddressViewStore>,
  GetState<AddressViewStore>,
  StoreApiWithPersist<AddressViewStore> & StoreApiWithDevtools<AddressViewStore>
>(
  devtools(
    persist(
      immer((set) => ({
        view: 'grid',
        setView: (view: AddressView) => {
          set((state) => {
            state.view = view
          })
        }
      })),
      {
        name: 'nfd-address-view',
        version: 0
      }
    ),
    { name: 'local-storage' }
  )
)
